module.exports = function(h, row) {
    if (_.isEmpty(row.outlets)) {
        return <i>Visible to all outlets</i>;
    }

    if (row.outlets.length === 1) {
        return row.outlets[0].name;
    }

    return <i>Visible to {row.outlets.length} outlets</i>;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/payment/outlets.jsx